import { render, staticRenderFns } from "./CorporationPage.vue?vue&type=template&id=541c756e&"
import script from "./CorporationPage.vue?vue&type=script&lang=js&"
export * from "./CorporationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports